export { ProductTileTitle } from './title'
export type { ProductTileTitleProps } from './title.types'
